
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulations",
      function () {
        return require("private-next-pages/regulations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulations"])
      });
    }
  